// 依赖jquery
import $ from "jquery"
// 引入i18n这个很重要，切换中英文更能依赖
import i18n from 'jqi18n'

const baseFlag = true

function chanLan() {
  let lang = ''
  if (this.baseFlag){
      lang = 'zh'
  }else {
    lang = 'en'
  }
  $.i18n.properties({
    name: 'strings', //属性文件名     命名格式： 文件名_国家代号.properties
    path: 'static/i18n', //注意这里路径是你属性文件的所在文件夹
    mode: 'map',
    language: lang, //这就是国家代号 name+language刚好组成属性文件名：strings+zh -> strings_zh.properties
    callback: function () {
      $("[data-locale]").each(function () {
        // console.log($(this).data("locale"));
        $(this).html($.i18n.prop($(this).data("locale")));

      });
    }
  });
}

export default {
  baseFlag,
  changeFlag(){
    this.baseFlag = !this.baseFlag
  },
  chanLan
  // install: function (Vue) {
  //   // Vue.prototype.$chanLan = (param) => chanLan()
  //   Vue.prototype.$chanLan = () => chanLan()
  // }
}



// WEBPACK FOOTER //
// ./src/api/globalFunc.js